import React from 'react';
import useDetailQuery from './useDetailQuery';

export default function withDetailQuery (WrappedComponent) {
	const ReturnedComponent = (props) => {
		const {
			query,
			id,
			detailQueryOptions,
			posType,
		} = props;

		const {
			data, loading, error, refetch,
		} = useDetailQuery(query, id, detailQueryOptions, posType);

		return (
			// eslint-disable-next-line react/jsx-filename-extension
			<WrappedComponent
				data={data}
				loading={loading}
				error={error}
				refetch={refetch}
				{...props}
			/>
		);
	};

	return ReturnedComponent;
}
